import { Crown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';
import { cn } from 'lib/utils';

type OwnerBadgeProps = {
  className?: string;
};

/** Small owner icon with tooltip — no text chip. */
export function OwnerBadge({ className }: OwnerBadgeProps) {
  const { t } = useTranslation();
  const label = t('OWNER', { defaultValue: 'Owner' });
  const tooltip = t('OWNER_TOOLTIP', {
    defaultValue: 'You are the owner. You can edit, share, and delete this agent.',
  });

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'inline-flex size-5 shrink-0 items-center justify-center rounded-full text-[#b45309] dark:text-amber-300',
              className
            )}
            aria-label={label}
          >
            <Crown className="size-3.5" aria-hidden />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export type { OwnerBadgeProps };
